import { apiClient } from "../../base/ApiClient";

// create allergy name in settings
export const createAllergyName = async (allergyData) => {
  const response = await apiClient.post(`/client/allergy-types/`, allergyData);
  return response.data;
};

//  Allergy Types APIs
export const getAllergyTypes = async () => {
  const response = await apiClient.get(`client/allergy-types/`);
  return response.data;
};

// Allergy Apis
export const createAllergy = async (formData) => {
  return await apiClient.post(`/client/allergy/`, formData);
};

export const getAllergiesByID = async (clientID) => {
  const response = await apiClient.get(`/client/allergy/?client_id=${clientID}`);
  return response.data;
};

export const getAllergyByID = async (ID) => {
  const response = await apiClient.get(`/client/allergy/${ID}/`);
  return response.data;
};

export const updateAllergy = async (ID, formData) => {
  const response = await apiClient.put(`/client/allergy/${ID}/`, formData);
  return response.data;
};

export const deleteAllergyByID = async (ID) => {
  const response = await apiClient.delete(`/client/allergy/${ID}/`);
  return response.data;
};